module.exports = __webpack_public_path__ + "static/img/2-h3c.ed8d398e.png";